/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioVolumeSMinusIcon16Light } from './MediaAudioVolumeSMinusIcon16Light';
import { MediaAudioVolumeSMinusIcon16Regular } from './MediaAudioVolumeSMinusIcon16Regular';
import { MediaAudioVolumeSMinusIcon16Solid } from './MediaAudioVolumeSMinusIcon16Solid';
import { MediaAudioVolumeSMinusIcon20Light } from './MediaAudioVolumeSMinusIcon20Light';
import { MediaAudioVolumeSMinusIcon20Regular } from './MediaAudioVolumeSMinusIcon20Regular';
import { MediaAudioVolumeSMinusIcon20Solid } from './MediaAudioVolumeSMinusIcon20Solid';
import { MediaAudioVolumeSMinusIcon24Regular } from './MediaAudioVolumeSMinusIcon24Regular';
import { MediaAudioVolumeSMinusIcon24Solid } from './MediaAudioVolumeSMinusIcon24Solid';
import { MediaAudioVolumeSMinusIcon32Regular } from './MediaAudioVolumeSMinusIcon32Regular';
import { MediaAudioVolumeSMinusIcon64Regular } from './MediaAudioVolumeSMinusIcon64Regular';
var sizes = {
    16: {
        light: MediaAudioVolumeSMinusIcon16Light,
        regular: MediaAudioVolumeSMinusIcon16Regular,
        solid: MediaAudioVolumeSMinusIcon16Solid,
    },
    20: {
        light: MediaAudioVolumeSMinusIcon20Light,
        regular: MediaAudioVolumeSMinusIcon20Regular,
        solid: MediaAudioVolumeSMinusIcon20Solid,
    },
    24: {
        regular: MediaAudioVolumeSMinusIcon24Regular,
        solid: MediaAudioVolumeSMinusIcon24Solid,
    },
    32: {
        regular: MediaAudioVolumeSMinusIcon32Regular,
    },
    64: {
        regular: MediaAudioVolumeSMinusIcon64Regular,
    },
};
export var MediaAudioVolumeSMinusIcon = forwardRef('MediaAudioVolumeSMinusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
